const opcionesfecha = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
const configuracion_horas = {
    timeZone: 'America/Santiago',
    hour: '2-digit',
    minute: '2-digit'
}
module.exports = {
    opcionesfecha: opcionesfecha,
    configuracion_horas
}